import './utils/polyfill'
import Vue from 'vue'
// import { sync } from 'vuex-router-sync'
import clone from 'clone'
import './element-ui'
import App from './App'
import router from './router'
import store from './store'

// 全局组件
import './utils/components'

// deep clone
Vue.prototype.$clone = clone

Vue.config.productionTip = false

// 将路由数据同步到store中，通过this.$store.route可以访问、只读
// sync(store, router)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js